"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Write a {@link Locked} update constraint to the stream
 */
function write(bos, value) {
    Codec.writeString(bos, value.getLockName());
    Codec.writeInt64(bos, value.getSequence());
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/locked-serialiser.js
// module id = 2028
// module chunks = 1